// Reducer Path
export const RESPONSIVE = "responsive";

// Action Path
export const CHANGE_SCREEN = RESPONSIVE + "/changeScreen";